export const givechakImage = 'https://static.tickchak.co.il/images/app/mail/defaultGivechakImage.png';
export const givechakLogo = 'https://static.tickchak.co.il/images/app/mail/givechakLogo.png';
export const givechakImageOld = 'https://static.tickchak.co.il/images/app/mail/givechak.png';
